var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7534 5.22659L14.8601 1.23992C13.5401 0.479922 11.4734 0.479922 10.1534 1.23992L3.19344 5.25325C0.433438 7.11992 0.273438 7.39992 0.273438 10.3733V17.6133C0.273438 20.5866 0.433438 20.8799 3.24677 22.7733L10.1401 26.7599C10.8068 27.1466 11.6601 27.3333 12.5001 27.3333C13.3401 27.3333 14.1934 27.1466 14.8468 26.7599L21.8068 22.7466C24.5668 20.8799 24.7268 20.5999 24.7268 17.6266V10.3733C24.7268 7.39992 24.5668 7.11992 21.7534 5.22659ZM12.5001 18.3333C10.1134 18.3333 8.16677 16.3866 8.16677 13.9999C8.16677 11.6133 10.1134 9.66659 12.5001 9.66659C14.8868 9.66659 16.8334 11.6133 16.8334 13.9999C16.8334 16.3866 14.8868 18.3333 12.5001 18.3333Z",
    fill: "#E7F1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketExpertise);
export default __webpack_public_path__ + "static/media/market-expertise.4d36c39aac4844d8871fab11437c22b8.svg";
export { ForwardRef as ReactComponent };